import "./App.css";
import "./components/css/mycss.css";
import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import { Navbar } from "./components/Navbar";
import { Carousel } from "./components/Carousel";
import { CardDisplay } from "./components/CardDisplay";
import { CardDisplay2 } from "./components/CardDisplay2";
import Weather from "./components/Weather";
import DateTime from "./components/DateTime";
import Footer from "./components/Footer";
import Quiz from "./components/Quiz";
import ArtsAwards from "./components/ArtsAwards";
import ScienceAwards from "./components/ScienceAwards";
import LitAwards from "./components/LitAwards";
import SportsAwards from "./components/SportsAwards";
import SocialAwards from "./components/SocialAwards";
import BussAwards from "./components/BussAwards";
import StateAwards from "./components/StateAwards";
import InterAwards from "./components/InterAwards";
import SearchResults from "./components/SearchResults"; 

export default function App() {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://code.jquery.com/jquery-3.7.1.min.js";
    script.integrity = "sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo=";
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
  }, []);

  return (
    <div className="App max-w-screen-xl mx-auto p-4">

      <div className="weatherbox flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
        <DateTime />
        <Weather />
      </div>

      <Navbar />
      <Carousel />

      <Routes>

        {/* HOME PAGE */}
        <Route 
          path="/" 
          element={
            <>
              <section className="text-center my-8">
                <h1 className="heading">Gallantry Awards</h1>
                <h3 className="head2">Honoring bravery and valor displayed by the armed forces.</h3>
              </section>

              <CardDisplay />

              <section className="text-center my-8">
                <h1 className="heading">Civilian Awards</h1>
                <h3 className="head2">Awards recognizing extraordinary contributions to society.</h3>
              </section>

              <CardDisplay2 />
              <Footer/>
            </>
          }
        />

        {/* CATEGORY ROUTES */}
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/arts" element={<ArtsAwards />} />
        <Route path="/science" element={<ScienceAwards />} />
        <Route path="/literature" element={<LitAwards />} />
        <Route path="/sports" element={<SportsAwards />} />
        <Route path="/social" element={<SocialAwards />} />
        <Route path="/business" element={<BussAwards />} />
        <Route path="/state" element={<StateAwards />} />
        <Route path="/international" element={<InterAwards />} />

        {/* 🔍 SEARCH RESULTS PAGE */}
        <Route path="/search" element={<SearchResults />} />

      </Routes>
    </div>
  );
}
